<script setup lang="ts">
import { LAWYER_INFO } from '@/pages/lawyer/model/keys';

const isMobile: boolean = useIsMobile();
const lawyerInfo = inject(LAWYER_INFO);

const title: ComputedRef<string> = computed(() =>
  lawyerInfo?.value?.company_id ? 'О нас' : 'О себе',
);
const description: ComputedRef<string> = computed(
  () => lawyerInfo?.value?.description ?? '',
);
</script>

<template>
  <article :class="['about-specialist', { _mobile: isMobile }]">
    <h2 class="about-specialist__title">{{ title }}</h2>
    <div v-if="description" class="about-specialist__content">
      <p>{{ description }}</p>
    </div>
  </article>
</template>

<style lang="less">
.about-specialist {
  &__title {
    font-weight: 600;
    font-size: @size-x6;
    line-height: 25px;
    color: @color-elephant;
    margin-bottom: @size-x5;
    margin-top: 0;
  }

  &__content p {
    font-weight: 500;
    font-size: @size-x4;
    line-height: 22px;
    color: @color-elephant;
    margin: 0;

    &:not(:last-child) {
      margin-bottom: @size-x8;
    }
  }

  &._mobile &__title {
    font-size: @size-x4;
    line-height: 22px;
    margin-bottom: @size-x4;
  }

  &._mobile &__content p {
    font-size: 14px;
    line-height: 19px;
    margin-bottom: @size-x6;

    &:last-child {
      margin-bottom: @size-x4;
    }
  }
}
</style>
